<!-- page starts-->
<section class="page-wrapper">
    <div class="ashton-hero-top-detail cf">
       <div class="container">
          <div class="ashton-hero-center-detail news cf">
             <div class="red-titel">MATCH DAY PROGRAM</div>
             <div class="match-day-pragram-section cf">
                <div class="match-day-pragram-section-inner">
                    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slidematchdayprogramConfig" *ngIf="hospitalityList?.data?.length > 0">
                        <div ngxSlickItem class="match-day-pragram-box slide" *ngFor="let hospital of hospitalityList?.data">
                            <div class="match-day-pragram-image">
                                <img [src]="hospital?.image">
                            </div>
                            <div class="match-day-pragram-btn">
                                <a href="{{hospital?.pdf}}" target="_blank">View</a>
                            </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
             </div>
          </div>
       </div>
    </div>
  </section><!-- page ends -->